import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { InactivityService } from '../../../pages/services/inactivity.service';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class UserMenuComponent implements OnInit {
  public userImage = '../assets/img/users/user.jpg';
  constructor(
    private router: Router,
    private inactivity: InactivityService
  ) {}

  ngOnInit() {
  }

  logout(): void {
    this.inactivity.stopWatching();
    sessionStorage.clear();
    this.router.navigate(['/login']);
  }
}
